<template>
  <div class="basket-group">
    <div class="basket-group-title">{{phrases.TEXT_ENTER_PROMOCODE}}</div>
    <div class="basket-group-field">
      <input class="basket-group-input size-lg"
             :class="{'applied': (couponStatus === COUPON_STATUS_HAS_BEEN_APPLIED), 'not-applied': (couponStatus !== null && couponStatus !== COUPON_STATUS_HAS_BEEN_APPLIED)}"
             type="text" :placeholder="phrases.TEXT_IF_YOU_HAVE" @input="updateCoupon" :value="coupon"
             :disabled="(couponStatus !== null)">
      <div class="button-apply-coupon" :class="{'button-apply-coupon-icon': (couponStatus !== null)}" v-if="coupon_entered">
        <span v-if="couponStatus !== null" @click="dropCoupon()" class="pp-icon pp-icon-close"></span>
        <span v-else @click="setCoupon()" class="button-apply-coupon-text">{{phrases.TEXT_APPLY}}</span>
      </div>
    </div>
    <div class="basket-note-text" :class="{'applied': (couponStatus === COUPON_STATUS_HAS_BEEN_APPLIED)}" v-text="coupon_request_text()"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Utils from "../Utils";

export default {
  name: "PromoCode",
  computed: {
    ...mapGetters('order', {
      coupon: 'getCoupon',
      couponStatus: 'getCouponStatus',
    }),
    ...mapGetters('app', {
      phrases: 'getPhrases',
    }),
    coupon_entered: function (){
      return (this.coupon !== null && this.coupon.length > 1);
    },
  },
  methods: {
    coupon_request_text: function (){
      if(this.coupon_entered) {
        if (this.process_discount) {
          return this.phrases.TEXT_PROCESS_REQUEST;
        }

        if(this.couponStatus !== null) {
          const statusText = 'TEXT_' + this.couponStatus;
          return this.phrases[statusText] !== undefined ? this.phrases[statusText] : 'ERROR';
        }
      }
      return "";
    },
    updateCoupon: function (e){
      this.$store.commit('order/setCoupon', e.target.value);
    },
    dropCoupon: function (){
      this.$store.commit('order/setCoupon',  null);
      this.$store.commit('order/setCouponStatus', null);
      this.calculateDiscount();
    },
    setCoupon: function (){
      this.calculateDiscount(true);
    }
  },
  mixins: [Utils],
}
</script>

<style scoped lang="scss">
.button-apply-coupon {
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
  line-height: 2rem;
  text-align: center;
  padding: 0 0.25rem;
  cursor: pointer;

  &-icon {
    width: 2rem;
    padding: 0;
  }

  &-text {
    font-family: "Panton Semibold", sans-serif;
  }
}

.applied {
  color: #748C33;
}

.not-applied {
  color: #e56621;
}
</style>